import styled from 'styled-components'

export const GeneralSettingsHeaderWrapper = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-between;
`
export const GeneralSettingsHeader = styled.div`
  display:flex;
  align-items:center;
`
export const GeneralSettingsWrapperImg = styled.div`
  width: 64px;
  heigth: 30px;
  display: flex;
  justify-content: center;
`

export const GeneralSettingsHeaderImg = styled.img``
export const GeneralSettingsTitle = styled.h3`
  color: #808080;
  font-weight: var(--font-weight-semibold);
  font-size: 18px;
  padding-left: 10px;
  margin-top: 0;
  margin-bottom: 0;
`

export const GeneralSettingsContentWrapper = styled.div`
  margin-left: 80px;
  font-size: 12px;

  .content__span {
    color: var(--color-contrast-brand);
    font-weight: var(--font-weight-semibold);
    margin-right: 1px;
  }

  .text {
    margin: 0;
  }

  label {
    text-transform: inherit !important;
  }
`

export const GeneralSettingsContentTitle = styled.h4`
  color: var(--color-action-default);
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  margin-bottom: 6px;
  margin-top: 3px;
`

export const GeneralSettingsContentText = styled.div`
  display: flex;
`

export const GeneralSettingsContent = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 0;

  .gereral-settings-save-button{
    display: flex;
    justify-content: center;
  }
`

export const GeneralSetting = styled.div`
  padding-bottom: 15px;
`

export const OptionGroupContent = styled.div`
  margin-top: -10px;
`

export const FeatureFlagsSection = styled.section`
  margin-top: 24px;
  padding: 20px 24px 24px;
  border: 1px solid var(--color-neutral-200);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`

export const FeatureFlagsHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`

export const FeatureFlagsTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FeatureFlagsTitle = styled.h4`
  margin: 0;
  color: var(--color-contrast-brand);
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
`

export const FeatureFlagsSubtitle = styled.p`
  margin: 0;
  color: var(--color-neutral-500);
  font-size: 12px;
`

export const FeatureFlagsSummary = styled.div`
  align-self: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(59, 73, 94, 0.08);
  color: var(--color-contrast-brand);
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
`


export const FeatureFlagsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;

  thead th {
    text-align: left;
    font-size: 12px;
    color: var(--color-neutral-500);
    font-weight: var(--font-weight-semibold);
    padding: 12px 0;
    border-bottom: 1px solid var(--color-neutral-200);
  }

  tbody td {
    padding: 16px 0;
    border-bottom: 1px solid var(--color-neutral-200);
    vertical-align: middle;
    font-size: 13px;
    color: var(--color-contrast-brand);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`

export const FeatureFlagsName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FeatureFlagsKey = styled.span`
  font-size: 11px;
  color: var(--color-neutral-500);
  font-family: monospace;
`

export const FeatureFlagsStatus = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 84px;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: var(--font-weight-semibold);

  &.enabled {
    color: var(--color-brand-500);
    background: rgba(0, 153, 224, 0.10);
  }

  &.disabled {
    color: var(--color-neutral-500);
    background: rgba(0, 0, 0, 0.04);
  }
`

export const FeatureFlagsFooter = styled.div`
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  .helper-text {
    color: var(--color-neutral-500);
    font-size: 12px;
  }
`

export const FeatureFlagsToggleCell = styled.td`
  width: 110px;
  text-align: right;
`
